import React, { useState, useEffect } from 'react';
import { Search, Calendar, User, ArrowRight, Tag, Share2, MessageCircle, Heart, Eye } from 'lucide-react';
import '../css/BlogPage.css';
import { Link } from 'react-router-dom';
import Footer from './Footer';


export const blogPosts = [
  {
    id: 1,
    slug: 'ai-personal-branding-2025',
    title: 'How to Build a Personal Brand Using AI in 2025',
    excerpt: 'Discover the revolutionary ways AI is transforming personal branding. From automated content creation to intelligent audience analysis, learn how to leverage AI tools to build an authentic, powerful personal brand.',
    content: 'The digital landscape is evolving rapidly, and AI is at the forefront of this transformation. Personal branding has never been more crucial, and AI tools are making it more accessible than ever before...',
    author: 'Sarah Chen',
    description: 'Building a personal brand with AI in 2025 offers unprecedented opportunities to scale your reach, create consistent content, and engage authentically with your audience. Learn how to leverage AI effectively while maintaining your unique voice and credibility. Define Your AI-Enhanced Brand Strategy by identifying your core expertise and unique perspective. AI works best when it amplifies your existing knowledge rather than replacing it. Determine which aspects of your brand building can benefit from AI assistance - content creation, audience research, engagement optimization, or visual design. For Content Creation and Scaling, AI can dramatically increase your content output while maintaining quality. Use AI writing tools to help draft blog posts, social media content, and newsletters, but always add your personal insights and experiences. AI can help you repurpose a single piece of content across multiple platforms - turning a blog post into social media threads, video scripts, and email newsletters. Consider using AI for content ideation by analyzing trending topics in your industry, suggesting angles you might not have considered, and helping you stay current with conversations in your field. However, ensure your content reflects your authentic voice by editing AI-generated drafts to match your tone and perspective. Visual Brand Development through AI image generation tools can help create consistent visual branding across platforms. Develop a signature style for graphics, social media posts, and marketing materials. Use AI to generate professional headshots, create branded templates, and design visual content that aligns with your brand aesthetic. Leverage AI analytics tools for Audience Research and Engagement to understand your audience better. AI can analyze engagement patterns, identify your most effective content types, and suggest optimal posting times. Use these insights to refine your content strategy and build stronger connections with your audience. AI chatbots can help manage initial audience interactions, but ensure they\'re programmed to reflect your brand voice and values. For deeper engagement, always prioritize personal interaction over automated responses.',
    date: '2025-07-01',
    readTime: '8 min read',
    category: 'Personal Branding',
    tags: ['AI', 'Personal Branding', 'Digital Marketing', 'Future Tech'],
    image: 'https://images.unsplash.com/photo-1677442136019-21780ecad995?w=800&h=400&fit=crop',
    featured: true,
    views: 2847,
    likes: 156,
    comments: 23
  },
  {
    id: 2,
    slug: 'visual-tools-creators-2025',
    title: 'Top 5 Visual Tools Every Creator Needs in 2025',
    excerpt: 'Elevate your creative game with these cutting-edge visual tools. From AI-powered design assistants to advanced video editing platforms, discover the essential toolkit for modern creators.',
    content: 'The creative economy is booming, and having the right tools can make all the difference. Here are the top 5 visual tools that every creator should have in their arsenal...',
    author: 'Marcus Rodriguez',
    description: 'In 2025, visual content creators need powerful tools to stay competitive and produce stunning work efficiently. The landscape of creative tools has evolved dramatically, with AI-powered design assistants leading the revolution. These intelligent platforms can generate concepts, suggest layouts, and even create entire designs based on simple prompts, allowing creators to focus on strategy and refinement rather than starting from scratch. Advanced video editing platforms have become more intuitive and powerful, offering features like automatic color correction, intelligent audio syncing, and AI-driven content suggestions. Real-time collaboration tools enable seamless teamwork across global teams, with cloud-based platforms allowing multiple creators to work simultaneously on projects. Motion graphics software has integrated machine learning capabilities that can predict and suggest animations, making complex motion design accessible to creators without extensive technical backgrounds. 3D design tools have become more user-friendly, with AI-assisted modeling and rendering that significantly reduces production time. These tools offer drag-and-drop functionality, pre-built assets, and intelligent lighting systems that automatically optimize scenes. Template libraries powered by AI can generate custom templates based on brand guidelines and project requirements, ensuring consistency across all visual content. Color palette generators use machine learning to suggest harmonious color schemes based on mood, industry, or target audience preferences. Typography tools now offer AI-powered font pairing suggestions and automatic text formatting that maintains readability across different devices and platforms. Stock media platforms have evolved to include AI-generated images, videos, and audio, providing creators with unlimited unique assets. Quality control features automatically check for technical issues, brand compliance, and accessibility standards before content goes live. Integration capabilities allow these tools to work seamlessly together, creating efficient workflows that save time and reduce errors. The future of visual content creation lies in the intelligent automation of technical tasks, allowing creators to focus on storytelling, strategy, and innovation.',
    date: '2025-06-28',
    readTime: '6 min read',
    category: 'Creative Tools',
    tags: ['Design Tools', 'Visual Content', 'Creator Economy', 'Productivity'],
    image: 'https://images.unsplash.com/photo-1611224923853-80b023f02d71?w=800&h=400&fit=crop',
    featured: false,
    views: 1892,
    likes: 134,
    comments: 18
  },
  {
    id: 3,
    slug: 'creative-economy-revolution',
    title: 'The Creative Economy Revolution: What 2025 Holds for Independent Creators',
    excerpt: 'The creative economy is undergoing a massive transformation. Explore the trends, opportunities, and challenges that independent creators will face in 2025 and beyond.',
    content: 'We are witnessing an unprecedented shift in how creative work is valued, distributed, and monetized. The creative economy is no longer a side hustle...',
    author: 'Alex Thompson',
    description: 'The creative economy is experiencing a fundamental transformation that is reshaping how independent creators work, earn, and build sustainable businesses. In 2025, creators are no longer limited to traditional employment models or relying solely on platforms that take significant revenue shares. New technologies and business models are empowering creators to maintain ownership of their work while reaching global audiences. Direct-to-consumer platforms are eliminating intermediaries, allowing creators to build direct relationships with their audience and retain higher percentages of their earnings. Subscription-based models have evolved beyond simple monthly fees to include tiered memberships, community access, and personalized content experiences. NFTs and blockchain technologies are providing new ways for creators to monetize their work through unique digital ownership and royalty structures. AI tools are democratizing content creation, allowing individual creators to produce professional-quality work that previously required teams and expensive equipment. Virtual and augmented reality platforms are opening entirely new creative mediums and revenue streams for forward-thinking creators. The rise of creator-focused financial services, including specialized banking, investment platforms, and insurance products, is treating creative work as legitimate business ventures. Educational platforms are enabling creators to monetize their expertise through courses, workshops, and mentorship programs. Collaborative tools are facilitating new forms of creative partnerships and collective projects across geographic boundaries. Brand partnerships are becoming more sophisticated, with creators maintaining creative control while accessing resources and distribution networks. The gig economy is evolving to provide more stability and benefits for creative professionals. Data analytics and AI insights are helping creators understand their audience better and optimize their content strategy. Cross-platform integration is allowing creators to build cohesive brands across multiple channels and revenue streams. The challenge for independent creators in 2025 will be navigating this abundance of opportunities while maintaining their creative integrity and building sustainable, long-term careers.',
    date: '2025-06-25',
    readTime: '10 min read',
    category: 'Creative Economy',
    tags: ['Creator Economy', 'Independent Creators', 'Digital Transformation', 'Future of Work'],
    image: 'https://images.unsplash.com/photo-1552664730-d307ca884978?w=800&h=400&fit=crop',
    featured: false,
    views: 3421,
    likes: 287,
    comments: 45
  },
  {
    id: 4,
    slug: 'ai-tokens-creative-projects',
    title: 'AI-Generated Tokens: The Future of Creative Project Funding',
    excerpt: 'Explore how AI-generated tokens are revolutionizing creative project funding. Learn about the intersection of artificial intelligence, blockchain, and creative financing.',
    content: 'The convergence of AI and blockchain technology is creating new opportunities for creative project funding. AI-generated tokens represent a paradigm shift...',
    author: 'Elena Vasquez',
    description: 'AI-generated tokens are revolutionizing how creative projects receive funding by combining the power of artificial intelligence with blockchain technology to create new financial instruments and investment opportunities. These tokens represent a paradigm shift from traditional funding models, offering creators unprecedented access to capital while providing investors with novel ways to support and profit from creative ventures. The process begins with AI algorithms analyzing project proposals, market trends, and creator track records to generate tokens that reflect the potential value and risk profile of creative projects. Smart contracts automatically execute funding agreements, milestone payments, and revenue sharing without requiring intermediaries or traditional financial institutions. AI-powered valuation models assess creative projects based on factors like audience engagement, market demand, creator reputation, and projected returns, creating more accurate and fair funding mechanisms. Token holders gain various benefits including early access to content, exclusive experiences, voting rights on project decisions, and revenue sharing from successful projects. The technology enables micro-investments, allowing supporters to contribute small amounts to multiple projects while spreading risk across a diverse portfolio. AI continuously monitors project progress, adjusting token values based on real-time performance metrics and market conditions. This creates a dynamic funding ecosystem where successful projects can access additional capital through token appreciation. The decentralized nature of blockchain ensures transparency, security, and global accessibility, removing geographical barriers to creative funding. Creator communities can form around tokens, fostering collaboration and cross-promotion between projects. AI-driven matchmaking connects creators with relevant investors, sponsors, and collaborators based on compatibility and mutual benefit. The system includes built-in fraud detection and creator verification to protect investors while maintaining platform integrity. Secondary markets allow token trading, creating liquidity for investors and additional funding opportunities for creators. This innovative approach democratizes creative financing, making it possible for projects of all sizes to access capital while offering investors new ways to participate in the creative economy.',
    date: '2025-06-22',
    readTime: '7 min read',
    category: 'AI Tokens',
    tags: ['AI Tokens', 'Blockchain', 'Creative Funding', 'Innovation'],
    image: 'https://images.unsplash.com/photo-1639762681485-074b7f938ba0?w=800&h=400&fit=crop',
    featured: false,
    views: 1567,
    likes: 98,
    comments: 12
  },
  {
    id: 5,
    slug: 'storytelling-digital-age',
    title: 'Mastering Digital Storytelling: Engage Your Audience in the Age of AI',
    excerpt: 'In an AI-dominated world, human storytelling becomes even more valuable. Learn advanced techniques to craft compelling narratives that resonate with modern audiences.',
    content: 'As AI tools become more sophisticated, the art of human storytelling becomes our greatest differentiator. Here\'s how to master digital storytelling...',
    author: 'David Kim',
    description: 'In an era where artificial intelligence can generate content at unprecedented speed and scale, human storytelling has become more valuable than ever as the key differentiator that creates genuine emotional connections with audiences. Mastering digital storytelling requires understanding how to leverage technology while maintaining authentic human elements that AI cannot replicate. The foundation of compelling digital storytelling lies in understanding your audience\'s deepest needs, fears, and aspirations, then crafting narratives that speak directly to these emotions. Multi-platform storytelling has evolved to create cohesive narratives across various digital channels, with each platform offering unique opportunities for different aspects of your story. Interactive storytelling engages audiences as active participants rather than passive consumers, using polls, quizzes, and user-generated content to create collaborative narratives. Visual storytelling combines compelling imagery, video, and graphics with narrative elements to create immersive experiences that capture attention in crowded digital spaces. Data-driven storytelling uses analytics and insights to understand what resonates with your audience, allowing you to refine your narrative approach based on real engagement metrics. Personal branding through storytelling involves consistently sharing authentic experiences, challenges, and victories that humanize your brand and build trust with your audience. The art of micro-storytelling adapts traditional narrative structures to shorter formats like social media posts, creating complete story arcs in limited space. Transmedia storytelling extends narratives across multiple platforms and formats, creating rich, interconnected story worlds that keep audiences engaged across different touchpoints. Emotional intelligence in storytelling focuses on understanding and triggering specific emotional responses that drive desired actions and behaviors. AI-assisted storytelling tools can help with research, ideation, and content optimization while preserving the human creativity and emotional authenticity that makes stories compelling. The future of digital storytelling lies in finding the perfect balance between technological efficiency and human creativity, using AI to enhance rather than replace the fundamental human elements that make stories memorable and impactful.',
    date: '2025-06-20',
    readTime: '9 min read',
    category: 'Personal Branding',
    tags: ['Storytelling', 'Digital Marketing', 'Content Creation', 'Audience Engagement'],
    image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=800&h=400&fit=crop',
    featured: false,
    views: 2134,
    likes: 189,
    comments: 27
  }
];

const categories = ['All', 'Personal Branding', 'Creative Tools', 'AI Tokens', 'Creative Economy'];

// BlogCard Component
const BlogCard = ({ post, isHero = false }) => {
  return (
    <Link to={`/blog/${post.slug}`} className={`blog-card ${isHero ? 'hero-card' : ''}`}>
      <div className="card-image-container">
        <img 
          src={post.image} 
          alt={post.title}
          className="card-image"
        />
      </div>
      <div className="card-content">
        <div className="card-badges">
          <span className="category-badge">
            {post.category}
          </span>
          {post.featured && (
            <span className="featured-badge">
              {/* Featured */}
            </span>
          )}
        </div>
        
        <h3 className="card-title">
          {post.title}
        </h3>
        
        <p className="card-excerpt">
          {post.excerpt}
        </p>
        
        <div className="card-meta">
          <div className="meta-info">
            <div className="meta-item">
              <User size={16} />
              <span>{post.author}</span>
            </div>
            <div className="meta-item">
              <Calendar size={16} />
              <span>{new Date(post.date).toLocaleDateString()}</span>
            </div>
          </div>
          <span className="read-time">{post.readTime}</span>
        </div>
        
        <div className="card-actions">
          <button className="read-more-btn">
           
            <ArrowRight size={16} />
          </button>
          
          <div className="engagement-stats">
            <div className="stat-item">
              <Eye size={16} />
              <span>{post.views}</span>
            </div>
            <div className="stat-item">
              <Heart size={16} />
              <span>{post.likes}</span>
            </div>
            <div className="stat-item">
              <MessageCircle size={16} />
              <span>{post.comments}</span>
            </div>
          </div>
        </div>
      </div>
    </Link>
  );
};

// BlogList Component
const BlogList = ({ posts, selectedCategory, searchTerm }) => {
  const filteredPosts = posts.filter(post => {
    const matchesCategory = selectedCategory === 'All' || post.category === selectedCategory;
    const matchesSearch = post.title.toLowerCase().includes(searchTerm.toLowerCase()) || 
                         post.excerpt.toLowerCase().includes(searchTerm.toLowerCase());
    return matchesCategory && matchesSearch;
  });

  return (
    <div className="blog-grid">
      {filteredPosts.map(post => (
        <BlogCard key={post.id} post={post} />
      ))}
    </div>
  );
};

// Sidebar Component
const Sidebar = ({ categories, selectedCategory, onCategoryChange, searchTerm, onSearchChange }) => {
  const allTags = [...new Set(blogPosts.flatMap(post => post.tags))];
  
  return (
    <div className="blog-sidebar">
      {/* Search */}
      <div className="blog-sidebar-section">
        <h3 className="blog-sidebar-title">Search</h3>
        <div className="search-container">
          <Search className="search-icon" size={20} />
          <input
            type="text"
            placeholder="Search articles..."
            value={searchTerm}
            onChange={(e) => onSearchChange(e.target.value)}
            className="search-input"
          />
        </div>
      </div>

      {/* Categories */}
      <div className="blog-sidebar-section">
        <h3 className="blog-sidebar-title">Categories</h3>
        <div className="categories-list">
          {categories.map(category => (
            <button
              key={category}
              onClick={() => onCategoryChange(category)}
              className={`category-btn ${selectedCategory === category ? 'active' : ''}`}
            >
              {category}
            </button>
          ))}
        </div>
      </div>

      {/* Tags */}
      <div className="blog-sidebar-section">
        <h3 className="blog-sidebar-title">Popular Tags</h3>
        <div className="tags-container">
          {allTags.map(tag => (
            <span key={tag} className="tag-item">
              <Tag size={12} />
              {tag}
            </span>
          ))}
        </div>
      </div>

      {/* Newsletter */}
      <div className="blog-sidebar-section newsletter-section">
        <h3 className="blog-sidebar-title">Stay Updated</h3>
        <p className="newsletter-text">Get the latest insights on creative tools, AI, and personal branding.</p>
        <div className="newsletter-form">
          <input
            type="email"
            placeholder="Enter your email"
            className="newsletter-input"
          />
          <button className="newsletter-btn">
            Subscribe
          </button>
        </div>
      </div>
    </div>
  );
};

// Main BlogPage Component
const BlogPage = () => {
  const [selectedCategory, setSelectedCategory] = useState('All');
  const [searchTerm, setSearchTerm] = useState('');
  const [featuredPost, setFeaturedPost] = useState(null);
  const [regularPosts, setRegularPosts] = useState([]);

  useEffect(() => {
    const featured = blogPosts.find(post => post.featured);
    const regular = blogPosts.filter(post => !post.featured);
    setFeaturedPost(featured);
    setRegularPosts(regular);
  }, []);

  return (
    <div className="blog-page">
      {/* Header */}
      <header className="blog-header">
        <div className="header-content">
          <h1 className="header-title">
            <span className="title-accent">Blog</span>
          </h1>
          <p className="header-subtitle">
            Empowering creators with insights on AI, personal branding, and the future of creative work
          </p>
        </div>
      </header>

      <div className="main-container">
        {/* Featured Post */}
        {featuredPost && (
          <div className="featured-section">
            <div className="feature-header">
              <div className="featured-icon">★</div>
              <h2 className="feature-title">Featured Article</h2>
            </div>
            <BlogCard post={featuredPost} isHero={true} />
          </div>
        )}

        <div className="content-wrapper">
          {/* Main Content */}
          <div className="main-content">
            <div className="content-header">
              <h2 className="content-title">Latest Articles</h2>
              <button className="share-btn">
                <Share2 size={20} />
                Share
              </button>
            </div>
            
            <BlogList 
              posts={regularPosts}
              selectedCategory={selectedCategory}
              searchTerm={searchTerm}
            />
          </div>

          {/* Sidebar */}
          <div className="blog-sidebar-container">
            <Sidebar
              categories={categories}
              selectedCategory={selectedCategory}
              onCategoryChange={setSelectedCategory}
              searchTerm={searchTerm}
              onSearchChange={setSearchTerm}
            />
          </div>
        </div>
      </div>

      {/* Footer */}
      <Footer/>
    </div>
  );
};

export default BlogPage;